"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.TabWrapper = exports.TabContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.TabContent = styled_components_1.default.div `
  display: flex;
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;
exports.TabWrapper = styled_components_1.default.div `
  display: flex;
  width: ${({ $fitContent }) => ($fitContent ? "fit-content" : "100%")};
`;
exports.Wrapper = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  width: 100%;
  border: ${({ $withoutBorder }) => ($withoutBorder ? "none" : `1px solid ${colors_1.GREY1}`)};

  @media screen and (max-width: 688px) {
    width: auto;
    height: auto;
  }
`;
//# sourceMappingURL=TabGroup.styles.js.map